﻿(function (angular) {
  "use strict";

  angular.module("Toyota", [
    "Toyota.Angulartics",
    "Toyota.Directives",
    "Toyota.Factories",
    "Toyota.Services",
    "Toyota.Components",
    "Toyota.Filters",
    "Toyota.Legacy",
    "ngTagsInput",
    "ng-directives-utils.transcludeReplace",
    "ngSanitize",
    "angulartics",
    "ngAnimate",
    "ngCookies",
    "directives.viewBox",
    "angularCancelOnNavigateModule",
    "angular-bind-html-compile",
    "ngDebottle",
    "ui.select",
  ]);

  // Namespaces
  angular.module("Toyota.Angulartics", []);
  angular.module("Toyota.Directives", []);
  angular.module("Toyota.Factories", []);
  angular.module("Toyota.Services", []);
  angular.module("Toyota.Filters", []);
  angular.module("Toyota.Components", []);
  angular.module("Toyota.Legacy", []);

  /* Config */
  angular
    .module("Toyota")
    .config([
      "$locationProvider",
      function ($locationProvider) {
        $locationProvider.html5Mode({
          enabled: true,
          requireBase: false,
          rewriteLinks: false,
        });
      },
    ])
    .config([
      "tagsInputConfigProvider",
      function (tagsInputConfigProvider) {
        tagsInputConfigProvider.setActiveInterpolation("tagsInput", { placeholder: true });
        tagsInputConfigProvider.setDefaults("tagsInput", { placeholder: "" });
      },
    ])
    .config([
      "$analyticsProvider",
      function ($analyticsProvider) {
        // turn off automatic tracking
        $analyticsProvider.virtualPageviews(false);

        $analyticsProvider.registerEventTrack(eventTrack);
        function eventTrack(event, properties) {
          var dataLayer = window.dataLayer || [];

          // eslint-disable-next-line no-param-reassign
          properties = properties || {};

          properties.event = event;
          delete properties.eventType;
          dataLayer.push(properties);
        }
      },
    ])
    .decorator("$q", [
      "$delegate",
      function ($delegate) {
        // Create a new promise object
        var promise = $delegate.when();

        // Access the `Promise` prototype
        var proto = Object.getPrototypeOf(promise);

        /*
         * Define a setter for `$$state` that creates a stacktrace
         * (string) and assigns it as a property of the internal `$$state` object.
         *
         * Adapted from:
         * https://stackoverflow.com/questions/41281515/possibly-unhandled-rejection-in-angular-1-6
         */
        Object.defineProperty(proto, "$$state", {
          enumerable: true,
          set: function (val) {
            val.stack = new Error().stack;
            this._$$state = val;
          },
          get: function () {
            return this._$$state;
          },
        });

        return $delegate;
      },
    ])
    .config([
      "$qProvider",
      function ($qProvider) {
        $qProvider.errorOnUnhandledRejections(true);
      },
    ]);
})(window.angular);
